module.exports = __webpack_public_path__ + "img/icon_wyyx.2418f438.png";